import { sendEvent } from "../metrics/events";

let lightboxCounter = 0;

function createFullscreenCarouselPlugin() {
  Alpine.directive(
    "fullscreen",
    async (el, { value, modifiers, expression }, { Alpine, effect, cleanup, evaluate }) => {
      const options = { gallery: el, children: `li:not([id*="clone"])` };
      if (modifiers.includes("children")) return;

      if (modifiers.includes("caption")) return;

      if (modifiers.includes("ext_slide")) return;

      let loop = true;

      const captionExpression = el.getAttribute("x-fullscreen.caption");
      if (captionExpression) {
        options.caption = {};
        options.caption.selector = captionExpression;
      }

      const childrenExpression = el.getAttribute("x-fullscreen.children");
      if (childrenExpression) {
        options.children = childrenExpression;
      }

      const extSlideExpression = el.getAttribute("x-fullscreen.ext_slide");
      if (extSlideExpression) {
        loop = false;
        options.extSlide = {
          selector: extSlideExpression,
        };
      }

      options.loop = loop;

      let lastIndex;

      const handlePhotoEvent = (event) => {
        const img = event.detail.element?.querySelector("img");
        const uuid = img?.dataset.imageUuid;
        lastIndex = event.detail.index;
        if (uuid) {
          sendEvent("images", uuid);
        }
      };

      lightboxCounter += 1;
      const LIGHTBOX_NAME = `lightbox_${lightboxCounter}`;

      const store = Alpine.store("modal");

      const handleOpening = (event) => {
        store.open(LIGHTBOX_NAME);
      };
      const handleClosing = (event) => {
        store.close(LIGHTBOX_NAME);
      };

      el.addEventListener("pswp-next-slide", handlePhotoEvent);
      el.addEventListener("pswp-opened", handleOpening);
      el.addEventListener("pswp-closed", handleClosing);

      const createLightbox = await window.wrappers.getLightbox();
      const lightbox = await createLightbox(options);

      const watch = (getter, callback) => {
        let oldValue = getter();
        effect(() => {
          const newValue = getter();
          if (newValue !== oldValue) {
            callback(newValue, oldValue);
            oldValue = newValue;
          }
        });
      };
      watch(
        () => store.isOpen(LIGHTBOX_NAME),
        (isOpen) => {
          if (!isOpen && lightbox.pswp) {
            const pswp = lightbox.pswp;

            const killPhotoSwipe = () => {
              try {
                if (lightbox.pswp) lightbox.pswp.close();
              } catch (e) {}
            };

            if (pswp.opener && !pswp.opener.isOpen) {
              pswp.on("openingAnimationEnd", killPhotoSwipe);
              setTimeout(killPhotoSwipe, 400);
            } else {
              killPhotoSwipe();
            }
          } else {
            if (!lightbox.pswp) {
              lightbox.loadAndOpen(lastIndex || 0);
            }
          }
        },
      );

      cleanup(() => {
        el.removeEventListener("pswp-next-slide", handlePhotoEvent);
        el.removeEventListener("pswp-opened", handleOpening);
        el.removeEventListener("pswp-closed", handleClosing);
        if (lightbox) {
          lightbox.destroy();
        }
      });
    },
  );
}

export { createFullscreenCarouselPlugin };
